// @flow
import * as React from 'react';
import EmptyQueueMessage from './EmptyQueueMessage';
import { type ModerationState } from 'models';

export default class ContentResponse extends React.PureComponent<
  {
    ugcId: UgcId,
    moderationState: ?ModerationState,
    requestContent: () => void,
    children?: React.Node,
  },
  void
> {
  render() {
    const { ugcId, requestContent, moderationState, children } = this.props;

    if (ugcId === -1) {
      return (
        <EmptyQueueMessage
          title="There is no content in your Queue."
          label="Refresh"
          onClick={requestContent}
        />
      );
    }

    if (!moderationState) {
      return (
        <EmptyQueueMessage
          title="Could not Load content"
          label="Retry"
          onClick={requestContent}
        />
      );
    }

    return children;
  }
}



// WEBPACK FOOTER //
// ./src/pages/__components__/ContentResponse.js